import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { Footer } from './components/Footer';
import { FeedbackWidget } from './components/FeedbackWidget';
import { TopBar } from './components/TopBar';
import { AdminPage } from './pages/AdminPage';
import { HomePage } from './pages/HomePage';
import { CreateBoardPage } from './pages/CreateBoardPage';
import { BoardPage } from './pages/BoardPage';
import { InfoPage } from './pages/InfoPage';
import { NotFoundPage } from './pages/NotFoundPage';

function AppContent(): JSX.Element {
  const location = useLocation();
  const isBoardRoute = location.pathname.startsWith('/board/');

  return (
    <div className="flex min-h-screen flex-col bg-gray-50 transition-colors duration-200 dark:bg-gray-950">
      {!isBoardRoute && <TopBar />}
      <main className="flex min-h-0 flex-1 flex-col">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/create" element={<CreateBoardPage />} />
          <Route path="/board/:boardId" element={<BoardPage />} />
          <Route path="/about" element={<InfoPage section="about" />} />
          <Route path="/privacy" element={<InfoPage section="privacy" />} />
          <Route path="/cookies" element={<InfoPage section="cookies" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!isBoardRoute && <Footer />}
      <FeedbackWidget />
    </div>
  );
}

function App(): JSX.Element {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
